import { approach } from '@/mocks/home';

export default function Approach() {
  return (
    <section id="approach" className="scroll-mt-14 relative w-full min-h-[600px] md:h-[92vh] md:min-h-[640px] overflow-hidden bg-primary-500 text-background-50">
      <img src="https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_auren-approach.webp" alt="Monumental architecture at dusk — AUREN approach" title="AUREN consulting approach" className="absolute inset-0 w-full h-full object-cover object-center" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/45 via-primary-950/25 to-primary-950/65" />
      <div className="relative h-full wrap flex flex-col py-14 md:py-16">
        <div className="flex items-start justify-between gap-6" data-reveal>
          <h2 className="h-sec">Fewer answers.<br />Better decisions.</h2>
          <span className="label-xs text-background-50/70 hidden sm:block pt-3">Approach</span>
        </div>
        <div className="mt-auto pt-16 grid grid-cols-1 md:grid-cols-3 border-t border-background-50/30">
          {approach.map((a, i) => (
            <div key={a.no} data-reveal className={`py-8 md:py-10 md:min-h-[220px] flex flex-col border-background-50/30 ${i > 0 ? 'border-t md:border-t-0 md:border-l md:pl-8' : 'md:pr-8'} ${i === 1 ? 'md:pr-8' : ''}`}>
              <span className={`label-xs ${i === 1 ? 'text-accent-300' : 'text-background-50/60'}`}>{a.no}</span>
              <h3 className="font-heading font-light uppercase tracking-[0.04em] text-3xl md:text-[40px] leading-none mt-5">{a.title}</h3>
              <p className="mt-4 text-[15px] leading-[1.6] text-background-50/80 max-w-[320px]">{a.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}